export default __webpack_public_path__ + "fonts/Gotham-Bold.e06f91ff4e2bc4d970af643ad3635c33.eot";